import * as Sentry from "@sentry/react";

const USER_STORAGE_KEY = "duas-vidas-user";

// Anexa o usuario autenticado ao escopo do Sentry, para que os eventos
// deixem de chegar anonimos no painel (permite responder "quantos usuarios
// isso afetou" e reproduzir o caso). Nunca usamos `sendDefaultPii: true`
// para isso — o usuario e anexado explicitamente aqui.
//
// Chame apos login, apos logout/expiracao de sessao, e uma vez no boot da
// aplicacao (para restaurar o contexto de uma sessao ja existente).
export function syncSentryUser(): void {
  try {
    const raw = localStorage.getItem(USER_STORAGE_KEY);

    if (!raw) {
      Sentry.setUser(null);
      return;
    }

    const user = JSON.parse(raw) as {
      id?: string;
      email?: string;
      role?: string;
    };

    if (!user?.id) {
      Sentry.setUser(null);
      return;
    }

    Sentry.setUser({
      id: user.id,
      email: user.email,
      role: user.role,
    });
  } catch {
    // JSON corrompido no localStorage nao deve derrubar a aplicacao.
    Sentry.setUser(null);
  }
}

export function clearSentryUser(): void {
  Sentry.setUser(null);
}
